import ContentItem from "@/models/ContentItem";

export default class CpDb {
    private db?: IDBDatabase;
    private defaultItems?: ContentItem[];

    init = async (defaultItems: ContentItem[]): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            this.defaultItems = defaultItems;

            let request = window.indexedDB.open("CopyPasteDatabase", 1);
    
            request.onsuccess = (event) => {
                this.db = (event.target as IDBOpenDBRequest).result;
                resolve();
            }
    
            request.onupgradeneeded = (event) => {
                let db: IDBDatabase = (event.target as IDBOpenDBRequest).result;
    
                console.log("upgrade");
                console.log(db);
    
                let objectStore = db.createObjectStore("items", { keyPath: "id", autoIncrement: true });
    
                objectStore.transaction.oncomplete = (event) => {
                    var itemStore = db.transaction("items", "readwrite").objectStore("items");
                    defaultItems.forEach((item) => {
                        itemStore.add(item);
                    });
                }
            }
        })
    }

    getAllItems = async (): Promise<ContentItem[]> => {
        return new Promise<ContentItem[]>((resolve, reject) => {
            if(this.db) {
                let items = new Array<ContentItem>();

                let objectStore = this.db.transaction("items").objectStore("items");
                objectStore.openCursor().onsuccess = (event) => {
                    let cursor = (event.target as IDBOpenDBRequest).result;
                    if (cursor) {
                        items.push(cursor.value);
                        cursor.continue();
                    }
                    else {
                        resolve(items);
                    }
                };
            }
            else {
                resolve(this.defaultItems || new Array<ContentItem>());
            }
        })
    }

    addItem = async (item: ContentItem): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (this.db) {
                let objectStore = this.db.transaction("items", "readwrite").objectStore("items");
                let request = objectStore.add(item);
                request.onsuccess = (event) => {
                    resolve();
                }
                request.onerror = (event) => {
                    reject("Add failed");
                }
            }
            else {
                reject("Can't add item");
            }

        })
    }

    removeItem = async (id: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (this.db) {
                let objectStore = this.db.transaction("items", "readwrite").objectStore("items");
                let request = objectStore.delete(id);
                request.onsuccess = (event) => {
                    resolve();
                }
                request.onerror = (event) => {
                    reject("Delete failed");
                }
            }
            else {
                reject("Can't delete item");
            }

        })
    } 
}


// WEBPACK FOOTER //
// ./src/data/CpDb.ts